import type { AutoSuggestedWork } from "@/api/queries";

import type { LegacyStoredSong, SongListItem } from "../types/setlist.types";

// str helper for t tags - avoids ts lint error
export const str = (s: string | null): string => s ?? "";

export function buildSelectedSongs(
  songList: SongListItem[],
  cachedSongs: AutoSuggestedWork[],
): Array<{ workcode: string; title: string; performingartists: string }> {
  return songList.map((song) => {
    const cached = cachedSongs.find(c => c.workcode === song.workcode);
    return {
      workcode: song.workcode ?? "",
      title: song.title.trim().length > 0 ? song.title : (cached?.title ?? ""),
      performingartists: song.performingartists ?? cached?.performingartists ?? "",
    };
  });
}

/**
 * Safely parses an unknown JSON.parse result into a LegacyStoredSong array.
 * Returns an empty array if the value is not an array.
 * Filters out any null/non-object entries that would cause runtime errors on field access.
 */
export function parseLegacyStoredSongs(value: unknown): LegacyStoredSong[] {
  if (!Array.isArray(value))
    return [];
  return value.filter((item): item is LegacyStoredSong =>
    item !== null && typeof item === "object" && !Array.isArray(item),
  );
}
